module.exports = __webpack_public_path__ + "img/menu4.6ce08a03.svg";